import { Locale, type LocalizedString } from "../Locale.js";
import { SolutionCategorization } from "../SolutionCategorization.js";

export const solutionCategorizationNameMap: Record<SolutionCategorization, LocalizedString> = {
	[SolutionCategorization.Tag]: {
		[Locale.cs]: "Podle typu",
	},
	[SolutionCategorization.Industry]: {
		[Locale.cs]: "Podle odvětví",
	},
};

export const solutionCategorizationLongNameMap: Record<SolutionCategorization, LocalizedString> = {
	[SolutionCategorization.Tag]: {
		[Locale.cs]: "Služby podle typu",
	},
	[SolutionCategorization.Industry]: {
		[Locale.cs]: "Služby podle odvětví",
	},
};

export const solutionCategorizationShortNameMap: Record<SolutionCategorization, LocalizedString> = {
	[SolutionCategorization.Industry]: {
		[Locale.cs]: "Odvětví",
	},
	[SolutionCategorization.Tag]: {
		[Locale.cs]: "Štítek",
	},
};
